export default __webpack_public_path__ + "static/media/innovation.f4e05e89.jpg";